// Mock data for Suryansh Dhiman's Portfolio

export const personalInfo = {
  name: "Suryansh Dhiman",
  title: "Software Engineer | Java | Selenium | Spring Boot",
  tagline: "Building scalable automation frameworks and backend systems",
  email: "suryanshdhiman1803@gmail.com",
  github: "https://github.com/Suryanshdhiman18",
  linkedin: "https://www.linkedin.com/in/suryansh-dhiman-58b352238/",
  avatar: "https://avatars.githubusercontent.com/u/avatar-placeholder"
};

export const about = {
  summary: "Associate Software Engineer with a strong focus on building robust automation frameworks and scalable backend systems. I specialize in creating maintainable test automation solutions using Java and Selenium, while also developing enterprise-grade applications with Spring Boot. My engineering approach emphasizes clean architecture, self-healing test frameworks, and solving real-world challenges in software quality and reliability."
};

export const skills = {
  automation: [
    { name: "Selenium WebDriver", level: 90 },
    { name: "TestNG Framework", level: 90 },
    { name: "Hybrid Framework Design (POM + Data Driven)", level: 85 },
    { name: "Healenium (Self-Healing Tests)", level: 80 },
    { name: "Applitools (Visual Testing)", level: 75 }
  ],
  apiTesting: [
    { name: "Rest Assured", level: 85 },
    { name: "Postman", level: 80 },
    { name: "API Automation", level: 85 },
    { name: "JUnit", level: 85 },
    { name: "Mockito", level: 80 }
  ],
  backend: [
    { name: "Java", level: 90 },
    { name: "Spring Boot", level: 85 },
    { name: "REST APIs", level: 85 },
    { name: "JPA", level: 85 },
    { name: "Spring Security", level: 75 },
    { name: "MVC Architecture", level: 85 },
    { name: "WebSockets", level: 70 },
  ],
  databases: [
    { name: "PostgreSQL", level: 80 },
    { name: "SQL Server", level: 75 }
  ],
  tools: [
    { name: "Git", level: 85 },
    { name: "Maven", level: 80 },
    { name: "Docker", level: 80 },
    { name: "Extent Reports", level: 85 },
    { name: "Log4j", level: 75 }
  ]
};

export const projects = [
  {
    id: 1,
    title: "Hybrid Automation Framework",
    description: "Enterprise-grade test automation framework built with Java and Selenium, implementing Page Object Model with self-healing capabilities and visual testing integration.",
    longDescription: "Designed and developed a comprehensive hybrid automation framework that combines data-driven and keyword-driven approaches. The framework addresses common automation challenges including flaky tests, maintenance overhead, and comprehensive reporting.",
    architecture: [
      "Page Object Model with Factory Pattern for efficient object creation",
      "TestNG for test orchestration and parallel execution",
      "Healenium integration for self-healing locators reducing maintenance by 40%",
      "Applitools Eyes for AI-powered visual regression testing",
      "Rest Assured for API layer validation",
      "Extent Reports with screenshot capture on failures",
      "Custom listeners for enhanced test lifecycle management"
    ],
    challenges: [
      "Eliminated flaky tests through robust wait strategies and Healenium",
      "Reduced test maintenance time by implementing smart locator strategies",
      "Integrated visual testing to catch UI regressions across browsers",
      "Implemented parallel execution reducing test suite runtime by 60%"
    ],
    techStack: ["Java", "Selenium", "TestNG", "Healenium", "Applitools", "Rest Assured", "Maven", "Extent Reports"],
    github: "https://github.com/Suryanshdhiman18/Intrics-test-automation",
    demo: null
  },
  {
    id: 2,
    title: "Real-time Chat Application",
    description: "Full-stack chat application built with Spring Boot backend, featuring real-time messaging, user authentication, and PostgreSQL database integration.",
    longDescription: "Developed a production-ready chat application demonstrating expertise in backend architecture, security implementation, and real-time communication. The application follows clean architecture principles with proper separation of concerns.",
    architecture: [
      "Layered architecture: Controller → Service → Repository pattern",
      "Spring Security for authentication and authorization",
      "JWT token-based session management",
      "RESTful API design following best practices",
      "PostgreSQL database with optimized queries",
      "WebSocket integration for real-time messaging",
      "Exception handling and validation layers"
    ],
    challenges: [
      "Implemented secure authentication with encrypted password storage",
      "Optimized database queries for message retrieval performance",
      "Handled concurrent user sessions and real-time updates",
      "Deployed to production with proper environment configuration"
    ],
    techStack: ["Spring Boot", "Java", "PostgreSQL", "Spring Security", "REST API", "WebSocket", "Maven"],
    github: "https://github.com/Suryanshdhiman18/chat-App",
    demo: "https://chat-app-tcwf.onrender.com/login.html"
  }
];

export const experience = [
  {
    id: 1,
    company: "RDSolutions",
    position: "Associate Software Engineer",
    duration: "April 2025 - Present",
    type: "Full-time",
    achievements: [
      "Built and maintained hybrid automation framework using Selenium, TestNG, and Healenium, reducing test maintenance effort by 40%",
      "Developed REST API test suites using Rest Assured with 95%+ code coverage",
      "Integrated Applitools for visual regression testing across multiple browsers and devices",
      "Implemented Spring Boot microservices with comprehensive unit and integration tests",
      "Collaborated with development teams to establish CI/CD pipelines with automated testing"
    ],
    awards: [
      "Rising Star Award 2025",
      "Co-Pilot Hackathon – Runner Up"
    ]
  }
];

export const services = [
  {
    id: 1,
    title: "Automation Framework Development",
    description: "Design and build custom test automation frameworks tailored to your tech stack, ensuring scalability and maintainability.",
    features: ["Page Object Model", "Hybrid Framework", "CI/CD Integration", "Reporting & Logging"]
  },
  {
    id: 2,
    title: "Selenium Test Automation",
    description: "End-to-end test automation for web applications using Selenium WebDriver with best practices and self-healing capabilities.",
    features: ["Cross-browser Testing", "Parallel Execution", "Self-healing Locators", "Visual Testing"]
  },
  {
    id: 3,
    title: "API Testing & Automation",
    description: "Comprehensive API testing solutions using Rest Assured and Postman, including automation and performance testing.",
    features: ["REST API Automation", "Schema Validation", "Performance Testing", "Documentation"]
  },
  {
    id: 4,
    title: "Backend Development",
    description: "Build robust backend systems and microservices using Spring Boot with proper architecture and database integration.",
    features: ["Spring Boot APIs", "Database Design", "Security Implementation", "Deployment"]
  },
  {
    id: 5,
    title: "Test Strategy & QA Consulting",
    description: "Expert guidance on test strategy, framework selection, and QA process optimization for your development lifecycle.",
    features: ["Strategy Planning", "Framework Selection", "Process Optimization", "Training"]
  },
  {
    id: 6,
    title: "CI/CD Pipeline Setup",
    description: "Configure automated testing pipelines integrated with your CI/CD workflow for continuous quality assurance.",
    features: ["Jenkins/GitLab CI", "Test Integration", "Automated Reporting", "Quality Gates"]
  }
];
